// Build-time-stamped version metadata for the widget.
//
// `__WIDGET_VERSION__` and `__WIDGET_COMMIT__` are string literals replaced
// by tsup's `define` config at bundle time. At dev/typecheck time they're
// declared via the ambient `declare const` below so TS is happy; the values
// you see there are NOT what ships — the tsup replacement wins.

declare const __WIDGET_VERSION__: string;
declare const __WIDGET_COMMIT__: string;

export const WIDGET_VERSION =
  typeof __WIDGET_VERSION__ === "string" ? __WIDGET_VERSION__ : "dev";

export const WIDGET_COMMIT =
  typeof __WIDGET_COMMIT__ === "string" ? __WIDGET_COMMIT__ : "dev";

export const WIDGET_COMMIT_SHORT =
  WIDGET_COMMIT === "dev" ? "dev" : WIDGET_COMMIT.slice(0, 7);

export const WIDGET_VERSION_LABEL = `v${WIDGET_VERSION} · ${WIDGET_COMMIT_SHORT}`;
